import ApiService from "../api";

export default class VeiculoService extends ApiService {

    constructor() {
        super('/api/veiculos')
    }

    listar() {
        return this.get("");
    }

    sincronizarFleetcom() {
        return this.post("/sincronizar-com-fleetcom");
    }

    listarByFilial(filialId) {
        return this.get(`/filial/${filialId}`);
    }

    listarByFilialSimples(filialId) {
        var params = "";
        if (filialId) params = filialId;
        return this.get(`/filial?filialId=${params}`);
    }

    listarPaginado(values = {}, pageable = {}) {
        const {
            placa = null,
            filialId = null,
            codigoYork = null,
            codigoSolar = null,
            modelo = null,
            tipo = null,
            ativo = null
        } = values;

        const {
            page = 0,
            size = 10,
            sortKey = "",
            sortDirection = "",
        } = pageable;

        const params = new URLSearchParams();

        if (filialId) params.append("filialId", filialId);
        if (placa) params.append("placa", placa);
        if (codigoSolar) params.append("codigoSolar", codigoSolar);
        if (codigoYork) params.append("codigoYork", codigoYork);
        if (modelo) params.append("modelo", modelo);
        if (tipo) params.append("tipo", tipo);
        if (ativo) params.append("ativo", ativo);

        params.append("page", page);
        params.append("size", size);

        if (sortKey && sortDirection) {
            params.append("sort", `${sortKey},${sortDirection}`);
        }

        return this.get(`/paginado?${params}`);
    }

    salvar(dto) {
        return this.post("", dto);
    }

    atualizar(id, dto) {
        return this.put(`/${id}`, dto);
    }

    buscarPorId(id) {
        return this.get(`/${id}`)
    }

    desativar(id) {
        return this.put(`/ativar-desativar/${id}`);
    }
}